export default "__VITE_ASSET__BJWaOoYy__"